// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const resetLaborRateHistoryCriteria = () => null;

const updateLaborRateHistoryCriteria = (state, action) => action.historyToDisplay;

export default (state = getDefaultState().historyToDisplay, action) => {

    const actionTypes = {
        [actions.RESET_LABOR_RATE_HISTORY_CRITERIA]: resetLaborRateHistoryCriteria,
        [actions.UPDATE_LABOR_RATE_HISTORY_CRITERIA]: updateLaborRateHistoryCriteria
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/labor-rate-history/reducers/criteria.js